import React from "react";
import HomeSlider from "./HomeSlider";
import Specialties from "../../Specialties/Specialties";
import Portfolio from "../../Portfolio/Portfolio";
import PhotoGallery from "../PhotoGallery/PhotoGallery";
import HappyCustomers from "../HappyCustomers/HappyCustomers";
import AboutMe from "../AboutMe/AboutMe";
import Status from "../Status/Status";
import GetinTouch from "../GetinTouch/GetinTouch";

const Home = () => {
  return (
    <div>
      <HomeSlider />
      <div className="bg-slate-50">
        <Specialties />
        <Portfolio />
        <PhotoGallery />
        <HappyCustomers />
        <AboutMe />
        <Status />
        <GetinTouch />
      </div>
    </div>
  );
};

export default Home;
